<template>
  <div role="main" class="dashboard-page">
    <dash-board-employee-component
      v-if="isCurrentRoleEmployee"
      class="container dashboard-page__content"
    />
    <dash-board-responsible-component
      v-if="isCurrentRoleResponsible"
      class="dashboard-page__content"
    />
  </div>
</template>

<script>
import {
  DashBoardEmployeeComponent,
  DashBoardResponsibleComponent,
} from "@/pages/dashboard/components";

import { WhoAmIMixin } from "@/components/mixins";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  mixins: [WhoAmIMixin],
  name: "DashBoardPage",
  layout: "MainLayout",
  middleware: ["auth", "notification"],
  components: {
    DashBoardEmployeeComponent,
    DashBoardResponsibleComponent,
  },
  computed: {
    ...mapGetters("auth", ["isCurrentRoleResponsible", "isCurrentRoleEmployee"]),
    ...mapState("auth", ["currentRole"]),
  },
  watch: {
    currentRole() {
      this.loadNotifications();
    },
  },
  methods: {
    ...mapActions("notification", ["loadNotifications"]),
  },
};
</script>

<style lang="scss" scoped>
.dashboard-page {
  position: relative;
  padding: 1.5rem 0 1.5rem;
}

.dashboard-page__content {
  position: relative;
  z-index: 1;
}

@media (max-width: 767.98px) {
  .dashboard-page {
    padding: 1.15rem 0 2rem;
  }
}
</style>
